import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '../../atoms/Text/Text';
import { AccordionContent, AccordionHeader, AccordionItem, AccordionTrigger } from '../Accordion/Accordion.styles';
import { CollapsibleContent, Icon, ItemContent, Slot, Wrapper } from './CheckGroupItem.styles';
export const CheckGroupItem = ({ className, /* Must be used together with `collapsibleValue` for proper controlling in `CheckGroup` */ collapsibleContentSlot, /* Must be used together with `collapsibleContentSlot` for proper controlling in `CheckGroup` */ collapsibleValue, 'data-testid': dataTestId, iconColor, iconName, isActive, leftSlot, onItemClick, text })=>/*#__PURE__*/ _jsx(Wrapper, {
        $isCollapsible: Boolean(collapsibleContentSlot),
        $isHighlighted: isActive,
        "data-testid": dataTestId,
        children: collapsibleContentSlot ? /*#__PURE__*/ _jsxs(AccordionItem, {
            value: collapsibleValue,
            children: [
                /*#__PURE__*/ _jsx(AccordionHeader, {
                    children: /*#__PURE__*/ _jsx(AccordionTrigger, {
                        onClick: onItemClick,
                        children: /*#__PURE__*/ _jsxs(ItemContent, {
                            className: className,
                            children: [
                                /*#__PURE__*/ _jsx(Slot, {
                                    children: leftSlot
                                }),
                                /*#__PURE__*/ _jsxs(Slot, {
                                    children: [
                                        iconName && /*#__PURE__*/ _jsx(Icon, {
                                            name: iconName,
                                            shiftColor: iconColor
                                        }),
                                        Boolean(text) && /*#__PURE__*/ _jsx(Text, {
                                            isBold: true,
                                            children: text
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(AccordionContent, {
                    children: /*#__PURE__*/ _jsx(CollapsibleContent, {
                        children: collapsibleContentSlot
                    })
                })
            ]
        }) : /*#__PURE__*/ _jsxs(ItemContent, {
            onClick: onItemClick,
            children: [
                /*#__PURE__*/ _jsx(Slot, {
                    children: leftSlot
                }),
                /*#__PURE__*/ _jsxs(Slot, {
                    children: [
                        iconName && /*#__PURE__*/ _jsx(Icon, {
                            name: iconName,
                            shiftColor: iconColor
                        }),
                        Boolean(text) && /*#__PURE__*/ _jsx(Text, {
                            isBold: true,
                            children: text
                        })
                    ]
                })
            ]
        })
    });

//# sourceMappingURL=CheckGroupItem.js.map